import { render } from "./KHeader.vue?vue&type=template&id=a8c8f1a0"
import script from "./KHeader.vue?vue&type=script&lang=js"
export * from "./KHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__